import { Controller } from 'stimulus';

import $ from 'jquery';

export default class extends Controller {
  static targets = ['duration'];

  initialize() {
    this.onMediaChange = this.onMediaChange.bind(this);
  }

  connect() {
    $(this.element).on('change', 'input:file', this.onMediaChange);
  }

  disconnect() {
    $(this.element).off('change', 'input:file', this.onMediaChange);
  }

  // ビデオをセットしたら duration を自動的に変更する
  onMediaChange(e) {
    if (e.currentTarget.id === 'lecture_media') {
      const file = e.currentTarget.files[0];
      if (file && /^video\//.test(file.type)) {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = () => {
          URL.revokeObjectURL(video.src);
          this.durationTarget.value = Math.ceil(video.duration / 60);
        };
        video.src = URL.createObjectURL(file);
      }
    }
  }
}
